<template>
  <button
    :disabled="!allValid"
    :name="fragment.uuid"
    class="btn btn-primary e2e-button"
    :value="fragment.uuid"
    @click.stop.prevent="onSubmit"
  >{{fragment.text}}</button>
</template>

<script>
import { feedbackToForm, BUS } from "./gfx";

export default {
  name: "fragment-gfx-submit",
  props: ["fragment"],
  data: function() {
    return {
      allValid: true
    };
  }, 
  methods: {
    async onSubmit() {
      const uuid = this.fragment.uuid;
      await this.$store.dispatch("sendForm", {
        form: feedbackToForm(uuid)
      });
    }
  },
  mounted() {
    const that = this; 
    BUS.$on("validated", function({ targetUuid, allValid }) {  
      const uuid = that.fragment.uuid; 
      if (uuid === targetUuid) {  
        that.allValid = allValid;
      }
    });
  }
};
</script>
 

<style scoped>
</style>